import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-doc-article-top-user-group',
  templateUrl: './doc-article-top-user-group.component.html',
  styleUrls: ['./doc-article-top-user-group.component.css']
})
export class DocArticleTopUserGroupComponent implements OnInit {
    docArticleTopUserGroupKeyno;

    public edit?: Edit;

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.docArticleTopUserGroupKeyno = this.stateService.getStateParams()['docarticletopusergroup_keyno'];
    }

    private async loadEdit() {
        if (!!this.docArticleTopUserGroupKeyno) {
            this.edit = (await this.datatask.Post(1383, { docarticletopusergroup_keyno: this.docArticleTopUserGroupKeyno }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(1384, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    docarticletopusergroup_keyno: string;
    title: string;
    usergroup_name: string;
    access: string;
}
